import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Topnav from '../TopNav/Topnav';
import Header from '../Header';
import Footer from '../Footer/Footer';
import styled from 'styled-components';

const API_URL = process.env.REACT_APP_API_URL;

const MaleModelsPage = () => {
  const [maleModel, setMaleModel] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  const getMaleModel = async () => {
    try {
      const [modelsRes, agentModelsRes] = await Promise.all([
        axios.get(`${API_URL}/api/models?filters[Category][$eq]=Male&filters[Payment][$eq]=Paid&populate=*&pagination[pageSize]=100`),
        axios.get(`${API_URL}/api/agent-models?filters[Category][$eq]=Male&filters[Payment][$eq]=Paid&populate=*&pagination[pageSize]=100`)
      ]);
    
      const modelsData = modelsRes.data.data.map(item => ({
        ...item,
        type: "model",
        uniqueId: `model-${item.id}`
      }));
  
      const agentModelsData = agentModelsRes.data.data.map(item => ({
        ...item,
        type: "agent-model",
        uniqueId: `agent-model-${item.id}`
      }));
  
      const combinedModels = [...modelsData, ...agentModelsData];
      setMaleModel(combinedModels);
      setIsLoading(false);
    } catch (err) {
      console.error(err);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getMaleModel();
  }, []);

  const filteredMovies = maleModel.filter(movie => {
    if (searchQuery && !movie.attributes.Name.toLowerCase().includes(searchQuery.toLowerCase())) {
      return false;
    }
    return true;
  });

  if (isLoading) {
    return (
      <>
        <Topnav/>
        <Header/>
        <Container>
          <LoadingMessage>Loading male models...</LoadingMessage>
        </Container>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Topnav/>
      <Header/>
      <Container>
        <PageHeader>
          <h1>Male Artists</h1>
          <SearchInput
            type="text"
            placeholder="Search male artists..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </PageHeader>

        <Content1>
          {filteredMovies.length > 0 ? (
            filteredMovies.map((model) => (
              <div key={model.uniqueId}>
                <Link
                  to={`/${model.type}/${model.id}`}
                  onClick={() => window.scrollTo(0, 0)}
                >
                  <div className="movieTrailers-container">
                    <img 
                      src={`${API_URL}${model.attributes?.Poster?.data?.attributes?.url}`} 
                      alt={model.attributes.Name} 
                      onError={(e) => {
                        e.target.src = '/placeholder-image.jpg';
                      }}
                    />
                    <div className="Movietrailers-overlay">
                      <p className="movieTrailers-title">{model.attributes.Name}</p>
                    </div>
                  </div>
                </Link>
              </div>
            ))
          ) : (
            <NoResultsMessage>
              {searchQuery ? `No male artists found for "${searchQuery}"` : 'No male artists available'}
            </NoResultsMessage>
          )}
        </Content1>
      </Container>
      <Footer />
    </>
  );
};

const Container = styled.main`
  min-height: calc(100vh - 70px);
  padding: 0 calc(3.5vw + 5px);
  position: relative;
  padding-bottom: 50px;
  overflow-x: hidden;
`;

const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 30px 0;
  padding: 20px;
  background-color: #101011;
  border-radius: 8px;
  
  h1 {
    color: #fff;
    margin: 0;
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }
`;

const SearchInput = styled.input`
  padding: 12px;
  border: 0px inset #ff0015;
  background-color: #212529;
  border-radius: 5px;
  color: #fba010;
  width: 300px;
  
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const LoadingMessage = styled.div`
  text-align: center;
  padding: 50px;
  font-size: 20px;
  color: #fff;
`;

const NoResultsMessage = styled.div`
  text-align: center;
  padding: 50px;
  font-size: 20px;
  color: #fff;
  grid-column: 1 / -1;
`;

const Content1 = styled.div`
  cursor: pointer;
  display: grid;
  grid-gap: 25px;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  
  img {
    width: 100%;
    height: 250px;
    object-fit: cover;
    opacity: 0.9;
    transition: transform 0.3s ease;
    
    &:hover {
      transform: scale(1.05);
    }
  }
  
  @media (max-width: 1200px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  
  @media (max-width: 900px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-gap: 15px;
    
    img {
      height: 200px;
    }
  }
  
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    
    img {
      height: 250px;
    }
  }
`;

export default MaleModelsPage;